// custom typefaces
// import 'typeface-montserrat';
// import 'typeface-merriweather';
import 'typeface-nunito';

// import "prismjs/themes/prism.css"
import 'prismjs/themes/prism-coy.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
